export const targetingPages = {
  placements: 'placements',
  locations_languages: 'locations_languages',
  devices_os: 'devices_os',
  exclude_rules: 'exclude_rules',
  custom_audience: 'custom_audience',
};

export const targetingNavigation = {};
